import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import BenefitsSection from './components/BenefitsSection';
import Screenshots from './components/Screenshots';
import DownloadSection from './components/DownloadSection';
import Footer from './components/Footer';
import BlogList from './components/blog/BlogList';
import BlogPost from './components/blog/BlogPost';
import LinkPage from "./components/link/LinkPage";
import QuizList from './components/quiz/QuizList';
import QuizPage from './components/quiz/QuizPage';
import FerramentasIndex from './components/tools/pages/FerramentasIndex';
import DotPage from './components/tools/pages/DotPage';
import FlexPage from './components/tools/pages/FlexPage';
import CnhPage from './components/tools/pages/CnhPage';
import UberPage from './components/tools/pages/UberPage';
import ViagemPage from './components/tools/pages/ViagemPage';
import CustoKmPage from './components/tools/pages/CustoKmPage';
import PrejuizosPage from './components/tools/pages/PrejuizosPage';
import VidaUtilPage from './components/tools/pages/VidaUtilPage';
import RecargaPage from './components/tools/pages/RecargaPage';
import NotFound from './components/NotFound';

// Landing page one-page (rota /)
const LandingPage: React.FC = () => (
  <>
    <Helmet>
      <title>Gas2 – Controle total do seu veículo</title>
      <meta
        name="description"
        content="Gas2 – Controle total do seu veículo. Registre abastecimentos, compare etanol x gasolina e acompanhe manutenções."
      />
      <link rel="canonical" href="https://gas2.app/" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Gas2" />
      <meta property="og:url" content="https://gas2.app/" />
      <meta property="og:title" content="Gas2 – Controle total do seu veículo" />
      <meta
        property="og:description"
        content="Gas2 – Controle total do seu veículo. Registre abastecimentos, compare etanol x gasolina e acompanhe manutenções."
      />
      <meta property="og:image" content="https://gas2.app/logo512.png" />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta property="og:locale" content="pt_BR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@gas2app" />
      <meta name="twitter:title" content="Gas2 – Controle total do seu veículo" />
      <meta
        name="twitter:description"
        content="Gas2 – Controle total do seu veículo. Registre abastecimentos, compare etanol x gasolina e acompanhe manutenções."
      />
      <meta name="twitter:image" content="https://gas2.app/logo512.png" />
    </Helmet>

    <Navbar />
    <main>
      <Hero />
      <FeaturesSection />
      <BenefitsSection />
      <Screenshots />
      <DownloadSection />
    </main>
    <Footer />
  </>
);

const BlogTagLegacyRedirect: React.FC = () => {
  const { tag } = useParams<{ tag: string }>();
  const encodedTag = encodeURIComponent(tag ?? '');

  return <Navigate to={`/blog${encodedTag ? `?tag=${encodedTag}` : ''}`} replace />;
};

// Orquestrador principal: SPA com roteamento para blog
const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/link" element={<LinkPage />} />
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/tag/:tag" element={<BlogTagLegacyRedirect />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      {/* Quiz routes */}
      <Route path="/quiz" element={<QuizList />} />
      <Route path="/quiz/:slug" element={<QuizPage />} />
      {/* Ferramentas automotivas */}
      <Route path="/ferramentas" element={<FerramentasIndex />} />
      <Route path="/ferramentas/validar-pneu-dot" element={<DotPage />} />
      <Route path="/ferramentas/calculadora-flex" element={<FlexPage />} />
      <Route path="/ferramentas/simulador-pontos-cnh" element={<CnhPage />} />
      <Route path="/ferramentas/calculadora-lucro-uber" element={<UberPage />} />
      <Route path="/ferramentas/calculadora-viagem" element={<ViagemPage />} />
      <Route path="/ferramentas/calculadora-custo-km" element={<CustoKmPage />} />
      <Route path="/ferramentas/simulador-maus-habitos" element={<PrejuizosPage />} />
      <Route path="/ferramentas/simulador-vida-util" element={<VidaUtilPage />} />
      <Route path="/ferramentas/calculadora-recarga-ev" element={<RecargaPage />} />

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default App;
